import { render, staticRenderFns } from "./purchaselistPR.vue?vue&type=template&id=526b1085&scoped=true"
import script from "./purchaselistPR.vue?vue&type=script&lang=js"
export * from "./purchaselistPR.vue?vue&type=script&lang=js"
import style0 from "./purchaselistPR.vue?vue&type=style&index=0&id=526b1085&prod&lang=css"
import style1 from "./purchaselistPR.vue?vue&type=style&index=1&id=526b1085&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b1085",
  null
  
)

export default component.exports